import { forceUpdate, h } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";
import loadTranslations from "../../utils/loadTranslations";
import { utcFromTime } from "../../utils/utcFromTime";
import { createPhoneLink } from "../../utils/createPhoneLink";
export class CreateServiceCaseSuccess {
    constructor() {
        /** Response from the API */
        this.response = null;
        /** Locale for the component */
        this.locale = null;
        /** BaseUrl for MyTrumpf */
        this.myTrumpfBaseUrl = "";
        /** used inside a modal */
        this.isInModal = false;
    }
    connectedCallback() {
        var _a;
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
        this.isInModal = ((_a = this.el) === null || _a === void 0 ? void 0 : _a.closest("ux-modal")) !== null;
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        var _a;
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        const time = (time) => time && h("ux-date-time", { key: 'a5c6b130cb8a3a10da9f811fcb03971c1ab1d5cd', utc: utcFromTime(time), format: t("timeFormat") });
        const { isOutsideOfServiceHours, technicalServiceHotline, technicalGuideAvailable, isCustomerOrderNumberRequired, sisCaseId, serviceHours } = ((_a = this.response) === null || _a === void 0 ? void 0 : _a[0]) || {};
        const hasMonFri = Boolean((serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriStart) && (serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriEnd));
        const hasSat = Boolean((serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatStart) && (serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatEnd));
        const monFriHtml = hasMonFri && (h("div", { key: 'f21e9d34767cf5f91b187612f001acb920b18fb8' }, t("sisConnector.success.serviceTimes.MonFri"), " ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriStart), " - ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriEnd)));
        const satHtml = hasSat && (h("div", { key: '67b58c0849182644956c02a574bb50309de270bb' }, t("sisConnector.success.serviceTimes.Sat"), " ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatStart), " - ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatEnd)));
        return (h("div", { key: '64f5f74d4dcd2fe8db026b2c8d77bbdf8536da61', class: "ux-u-text-align--center" }, h("div", { key: '7bc829e58dca2063d629f1506da9ba1578166ed6', class: "ux-u-mb-xxs" }, h("ux-icon", { key: '0ac1a50d1e2e98e729a2bda5ef2ae71c83f4472a', style: { fontSize: "100px" }, class: "ux-color-success ux-icon", name: "checkmark" })), h("div", { key: 'de03985e5e4556f80397b99c2efa2553500b4902', class: "ux-text-headline ux-text-headline--big ux-u-mb-xxs" }, t("sisConnector.success.headline")), isOutsideOfServiceHours && (h("div", { key: 'b537753e4b3b65fbaa1b042779dec18a1de79226', class: "ux-text-normal" }, h("p", { key: 'd94aaca81f462f61beb02fc881ca732784814284' }, t("sisConnector.success.outsideOfServiceHours")), h("strong", { key: 'f4a8877afcd6f9080d7b589e3f59d2d591eb6dc1' }, monFriHtml, satHtml))), technicalServiceHotline && (h("p", { key: '780489f64a1e283c8ee1a289398c9b28ea7a97cb', class: "ux-text-normal", innerHTML: t("sisConnector.success.withTechnicalServiceHotline", {
                hotline: createPhoneLink(technicalServiceHotline, "mf-create-service-case-success__link"),
                interpolation: { escapeValue: false }
            }) })), !technicalServiceHotline && (h("p", { key: '33a02e319b7c966c026d46a0c660932d4dfb9fb3', class: "ux-text-normal" }, t("sisConnector.success.withoutTechnicalServiceHotline"))), technicalGuideAvailable && (h("div", { key: 'f3a70c1c203051dc298dcd70965c23ddb044d57a' }, h("div", { key: '5487c98e2cf0719e4a82bc59efa51ed017bd8fd8', class: "ux-text-headline--big" }, t("sisConnector.success.technicalGuide.title")), h("p", { key: '92b983084e25e6fb02be2c6d603ebcf173b1d58a', class: "ux-text-normal" }, t("sisConnector.success.technicalGuide.text")))), isCustomerOrderNumberRequired && (h("div", { key: 'feca983395f62d1d3c5b07e44c981e4a585172f9' }, h("div", { key: '744a0b8848eb2eb8268678d21ca738c0f93dadf4', class: "ux-text-headline--big" }, t("sisConnector.success.orderNumberRequired.title")), h("p", { key: 'bde20fc1bc77ab14244b3b4e45b192f66cfc587c', class: "ux-text-normal" }, t("sisConnector.success.orderNumberRequired.text")))), h("div", { key: '22bf71eb731600e40df3c87a5cf9e46184346f81', class: "ux-text-normal" }, h("p", { key: '60d8d1722ad406b0b12be960baba5fb0cf0bbc4a' }, h("a", { key: 'fed5c89a6ba392473849a4ee05c6856e1d22ff30', class: "mf-create-service-case-success__link", href: `${this.myTrumpfBaseUrl}/go/mytrumpf/my-service-cases/case/${sisCaseId}/` }, t("sisConnector.success.caseId"), ": ", sisCaseId))), !this.isInModal && (h("ux-button", { key: 'eaa898d4de108965c8dbec1bba68140bcba91606', class: "ux-u-margin-top-20", type: "button", variant: "primary", onClick: () => { var _a; return (_a = this.clickHandler) === null || _a === void 0 ? void 0 : _a.call(this); }, formnovalidate: true }, t("button.ok")))));
    }
    static get is() { return "mf-create-service-case-success"; }
    static get originalStyleUrls() {
        return {
            "$": ["create-service-case-success.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["create-service-case-success.css"]
        };
    }
    static get properties() {
        return {
            "response": {
                "type": "unknown",
                "attribute": "response",
                "mutable": false,
                "complexType": {
                    "original": "CreateCaseResponse | null",
                    "resolved": "CreateCaseResponseItem[] | null",
                    "references": {
                        "CreateCaseResponse": {
                            "location": "import",
                            "path": "../../api/publicApi/createCase/createCase",
                            "id": "src/api/publicApi/createCase/createCase.ts::CreateCaseResponse"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Response from the API"
                },
                "getter": false,
                "setter": false,
                "defaultValue": "null"
            },
            "clickHandler": {
                "type": "unknown",
                "attribute": "click-handler",
                "mutable": false,
                "complexType": {
                    "original": "() => void",
                    "resolved": "() => void",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Click handler for the success button"
                },
                "getter": false,
                "setter": false
            },
            "locale": {
                "type": "string",
                "attribute": "locale",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Locale for the component"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "null"
            },
            "myTrumpfBaseUrl": {
                "type": "string",
                "attribute": "my-trumpf-base-url",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "BaseUrl for MyTrumpf"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "isInModal": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "locale",
                "methodName": "onLocaleChange"
            }];
    }
}
//# sourceMappingURL=create-service-case-success.js.map
